
import { gsap, Power4, Back } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import Keyboard, { KEYS } from '../_app/cuchillo/core/Keyboard';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from "../_app/cuchillo/utils/Ease";
import { isReducedMotion } from '../_app/cuchillo/core/Basics';
import { Functions } from '../_app/cuchillo/utils/Functions';

gsap.registerPlugin(SplitText);


export class TitularMagneticController {
  static _titles = {};
  static _observer = null;
  static _options = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
  };
  
  static init() {
    this.setupObserver();
    this.getTitles();
  };

  static getTitle(selector = "[data-text-animation]") {
      const dom = GetBy.selector(selector)[0];
      const title = new TitularMagneticReveal(dom, dom.dataset.textAnimation? {type:dom.dataset.textAnimation, time:.4, delay:100} : {});
      return title;
  };

  static getTitles(selector = "[data-text-animation]") {
    
    [...GetBy.selector(selector)].map(dom => {
      console.log(selector, dom);
      const id = Functions.getId(dom);
      const title = new TitularMagneticReveal(dom, dom.dataset.textAnimation? {type:dom.dataset.textAnimation, time:.4, delay:100} : {});
    
      this._titles[id] = title;

      if (!isReducedMotion) {
        this._observer.observe(dom);
      }
    });
  };

  static setupObserver() {
    if (this._observer) {
      this._observer.disconnect();
    }

    if (!isReducedMotion) {
      this._observer = new IntersectionObserver((entries) => { this.checkObserver(entries) }, this._options);
    }
  }

  static checkObserver(entries, observer) {
    entries.forEach(entry => {
      const id = Functions.getId(entry.target);
      const title = this._titles[id];

      if (entry.isIntersecting) {
        title.show();
      } else {
        title.reset();
      }
    });
  }

  static dispose() {
    if (this._observer) { this._observer.disconnect(); }

    Object.entries(this._titles).map((item) => { 
      item[1].dispose()
    });

    this._titles = {}
    this._observer = null;
  }
};


export class TitularMagneticReveal {
  
  _dom;
  _content;
  _items = [];
  _options = {
    type: "words",
    time: 1,
    speedW: 0,
    speedH: 0,
    delay: 200
  };
  _actual = 0;
  _width = 0;
  _height = 0;
  _widthTarget = 0;
  _heightTarget = 0;

  _calls = {
    loop: () => this.loop(),
  }

  _enabled = false;

  get enabled() { return this._enabled; }
  set enabled(__b) {
    if(this._enabled == __b) return;

    this._enabled = __b;
    if (this._enabled) {
      gsap.ticker.add(this._calls.loop);
    } else {
      gsap.ticker.remove(this._calls.loop);
    }
  }

  get width() { return this._width; }
  set width(__n) {
    this._width = __n;
    this._items[this._actual].dom.style.width = `${this._width}px`;
  }
  get height() { return this._height; }
  set height(__n) {
    this._height = __n;
    this._items[this._actual].dom.style.height = `${this._height}px`;
  }

  constructor(__dom, __opts = {}) {
    this._dom = __dom;
    this._content = GetBy.class('content', this._dom)[0];
    this._options = {
      ...this._options,
      ...__opts
    };

    this.setupText();

    Keyboard.add(KEYS.UP, "0", () => {this.show();})
  }

  setupText() {
    const temp = new SplitText(this._content, {type: `lines,${this._options.type}`})[this._options.type];
    let old = null;

    for (let i = temp.length - 1; i >= 0; i--) {
      const size = temp[i].parentNode.getBoundingClientRect();
      
      this._items.push({
        dom: temp[i],
        parent: temp[i].parentNode,
        width: size.width,
        height: size.height,
        delay: old != temp[i].parentNode? this._options.delay : this._options.delay,   
      });

      temp[i].style.display = 'none';
      temp[i].style.opacity = 0;
      old = temp[i].parentNode;
    }

    this._items = this._items.reverse();

    old = null;
    for (let i = 0; i < this._items.length; i++) {
      this._items[i].isFirst = old != this._items[i]? true : false
      this._items[i].parent.style.width = 0;
      this._items[i].parent.style.height = 0;
      old = this._items[i].parent;
    }
  }

  reset() {
    for (let i = 0; i < this._items.length; i++) {
      gsap.killTweensOf(this._items[i].parent);
      this._items[i].parent.style.width = 0;
      this._items[i].parent.style.height = 0;
      this._items[i].dom.style.display = 'none';
      this._items[i].dom.style.opacity = 0;
    }
    this._actual = 0;
  }


  show() {
    if(this._actual >= this._items.length) {
      this.enabled = false;
      return;
    }

   //this.enabled = true;

   gsap.to(this._items[this._actual].dom, {
    duration: 0.2,
    opacity: 1,
    ease: Power4.easeIn
  });

  if(this._items[this._actual].isFirst) {
    
    gsap.set(this._items[this._actual].parent, {
      width: this._items[this._actual].width * .6,
    });
  }

   gsap.to(this._items[this._actual].parent, {
      duration: this._options.time,
      width: this._items[this._actual].width,
      //ease: "back.out",
      ease: Ease.EASE_OUT
    });

    gsap.to(this._items[this._actual].parent, {
      duration: this._options.time,
      
      height: this._items[this._actual].height,
      ease: Ease.EASE_OUT
    });

    this._items[this._actual].dom.style.display = "inline-block";
    /*this._widthTarget = 0;
    this._heightTarget = 0;
    this._widtht = 0;
    this._height = 0;
    this._items[this._actual].dom.style.opacity = 1;
    this._widthTarget = this._items[this._actual].width;
    this._heightTarget = this._items[this._actual].height;*/

    setTimeout(() => {
      this._actual++;
      this.show();
    }, this._items[this._actual].delay);
  }

  loop() {
    this._options.speedW = (this._widthTarget - this._width) * this._options.ease;
    this._options.speedH = (this._heightTarget - this._height) * this._options.ease;

    this.width += this._options.speedW;
    this.height += this._options.speedH;
  }
}